import React, { useState } from "react";
import { TickMicro } from "../assets/SvgIcons";
import { useNavigate } from "react-router-dom";

const SubscriptionPlan = () => {
  return (
    <>
      <MainSection />
    </>
  );
};

export default SubscriptionPlan;

const MainSection = () => {
  const [selectedCycle, setSelectedCycle] = useState(1);
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 mb-20">
      <Header
        selectedCycle={selectedCycle}
        setSelectedCycle={setSelectedCycle}
      />
      <Packages
        selectedCycle={selectedCycle}
        setSelectedCycle={setSelectedCycle}
      />
    </section>
  );
};

const BillingCycleSelector = ({ selectedCycle, setSelectedCycle }) => {
  return (
    <div className="flex  bg-primarylight border border-secondary rounded-full">
      <button
        onClick={() => setSelectedCycle(1)}
        className={`px-8 py-2.5  rounded-full ${
          selectedCycle === 1
            ? "bg-secondary text-white border-r border-r-secondary"
            : "bg-transparent"
        }`}
      >
        Annual
      </button>
      <button
        onClick={() => setSelectedCycle(2)}
        className={`px-8 py-2.5  rounded-full ${
          selectedCycle === 2
            ? "bg-secondary text-white  border-r border-r-secondary"
            : "bg-transparent"
        }`}
      >
        Monthly
      </button>
    </div>
  );
};

const Header = ({ selectedCycle, setSelectedCycle }) => {
  return (
    <header className="flex justify-between items-center mb-6">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl ">Pricing</h2>

      <BillingCycleSelector
        selectedCycle={selectedCycle}
        setSelectedCycle={setSelectedCycle}
      />
    </header>
  );
};

const Packages = ({ selectedCycle }) => {
  const pkgs = [
    {
      plan: "Basic Plan",
      current: true,
      description:
        "Ideal for smaller dealers eager to expand and thrive. Gain access to WristLink's core features with absolute clarity on costs",
      cost: {
        monthly: "500",
        monthlyAnnual: "400",
        annually: "4800",
        promotionalText: "Save 20% on the annual plan",
      },
      featuresTitle: "Core features include: ",
      features: [
        "List up to 25 watches",
        "Trade and contact unlimited number of dealers a month",
      ],
      actions: {
        buyNow: {
          label: "Buy Now",
          url: "https://ecom.docusign.com/en-US/checkout?PLAN_BILLING_ID=35c1e091-ebdc-4de9-b0c8-1d5c4e642f00&planGroup=esignature",
        },
        viewAllFeatures: {
          label: "View all plan features",
        },
      },
    },
    {
      plan: "Professional Plan",
      current: true,
      description:
        "Designed for experienced dealers seeking enhanced network access and powerful tools to streamline and grow their business.",
      cost: {
        monthly: "3,000",
        monthlyAnnual: "2,400",
        annually: "28,800",
        promotionalText: "Save 20% on the annual plan",
      },
      featuresTitle: "Core features include:  ",
      features: [
        "Unlimited number of Listings",
        "Get your listings displayed at the top of any search with a premium and “verified banner”",
        "Have your listings displayed in the “featured” section",
        "Access the exclusive network of “premium dealers”",
        "Free access to wristlink trading events",
      ],
      actions: {
        buyNow: {
          label: "Buy Now",
          url: "https://ecom.docusign.com/en-US/checkout?PLAN_BILLING_ID=35c1e091-ebdc-4de9-b0c8-1d5c4e642f00&planGroup=esignature",
        },
        viewAllFeatures: {
          label: "View all plan features",
        },
      },
    },
    // {
    //   plan: "Business Pro",
    //   current: true,
    //   description:
    //     "For automating and optimizing agreements with advanced features",
    //   cost: {
    //     monthly: 40,
    //     annually: 480,
    //   },
    //   featuresTitle: "Core features include: ",
    //   features: [
    //     "Send five agreements for signature each month",
    //     "Save time and standardize with reusable templates",
    //     "Streamline your workflows with 900+ integrations",
    //     "Send five agreements for signature each month",
    //     "Save time and standardize with reusable templates",
    //     "Streamline your workflows with 900+ integrations",
    //   ],
    //   actions: {
    //     buyNow: {
    //       label: "Buy Now",
    //       url: "https://ecom.docusign.com/en-US/checkout?PLAN_BILLING_ID=35c1e091-ebdc-4de9-b0c8-1d5c4e642f00&planGroup=esignature",
    //     },
    //     viewAllFeatures: {
    //       label: "View all plan features",
    //     },
    //   },
    // },
  ];

  return (
    <div
      className={`grid mt-12 border-t ${
        pkgs?.length === 2
          ? "grid-cols-2"
          : pkgs?.length === 3
          ? "grid-cols-3"
          : pkgs?.length === 4
          ? "grid-cols-4"
          : "grid-cols-4"
      }`}
    >
      {pkgs?.map((pkg, index) => {
        return (
          <PackageCard
            pkg={pkg}
            selectedCycle={selectedCycle}
            index={index}
            key={index}
          />
        );
      })}
    </div>
  );
};

const PackageCard = ({ pkg, selectedCycle, index }) => {
  const navigate = useNavigate();
  return (
    <div className={`py-6  ${index !== 0 ? "border-l px-8" : "pr-8"}`}>
      <h3 className="lg:text-2xl md:text-xl sm:text-xl mb-6">{pkg?.plan}</h3>
      <p className="text-[14px]">{pkg?.description}</p>

      <div className="lg:flex justify-between items-end">
        <h3 className="lg:text-2xl md:text-xl sm:text-xl mt-6">
          {"AED"}{" "}
          {selectedCycle === 1 ? pkg?.cost?.monthlyAnnual : pkg?.cost?.monthly}
          <span className="text-[14px]">/month</span>
        </h3>

        {pkg?.cost?.promotionalText && selectedCycle === 1 && (
          <>
            <div className="flex lg:flex md:flex sm:hidden gap-2  rounded-full bg-primary  font-semibold">
              <p className="text-[18px] pl-1">&#9432;</p>{" "}
              <p className="text-[12px] pr-2.5 py-1">
                {pkg?.cost?.promotionalText}
              </p>{" "}
            </div>
            <div className="flex lg:hidden md:hidden sm:flex gap-2  items-center rounded-full bg-primary  font-semibold">
              <p className="text-[18px] pl-1">&#9432;</p>{" "}
              <p className="lg:text-[12px] md:text-[10px] sm:text-[9px] pr-2.5 py-1">
                {pkg?.cost?.promotionalText}
              </p>{" "}
            </div>
          </>
        )}
      </div>

      {selectedCycle === 1 && (
        <p className="text-secondarylight text-[14px]">
          {"AED "}
          {pkg?.cost?.annually} billed annually
        </p>
      )}

      <button
        onClick={() =>
          navigate("/dealer-info/registration-info?step=1", {
            state: {
              amount:
                selectedCycle === 1 && index === 0
                  ? 4800
                  : selectedCycle === 1 && index === 1
                  ? 28800
                  : selectedCycle === 2 && index === 0
                  ? 500
                  : 3000,
              cycle: selectedCycle === 1 ? "Year" : "Month",
            },
          })
        }
        className="py-4 my-6 w-full rounded bg-secondary text-white font-semibold"
      >
        {" "}
        Buy Now
      </button>

      <p className="text-[13px] mb-2">{pkg?.featuresTitle}</p>
      <ul>
        {pkg?.features?.map((feature, index2) => {
          return (
            <li key={index2} className="flex gap-1 items-start text-[13px]">
              <span className="mt-1">{TickMicro}</span> {feature}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
